import { Provider } from '@angular/core';

import { WithholdingUseCasesImpl } from '@app/domain/use-cases/ptrab/withholding/withholding.use-cases';
import { WITHHOLDING_USE_CASES } from '@app/domain/use-cases/ptrab/withholding/withholding.use-cases.contract';

export const withholdingUseCasesProvider: Provider = {
  provide: WITHHOLDING_USE_CASES,
  useClass: WithholdingUseCasesImpl
};
